import React from 'react';
import { gql } from '@apollo/client';
import {
  ArrayField,
  BooleanField,
  Datagrid,
  FunctionField,
  Show,
  Tab,
  TabbedShowLayout,
  TabbedShowLayoutTabs,
  TextField,
} from 'react-admin';
import MoneyField from 'components/MoneyField';
import IdField from 'components/IdField';
import LinkField from 'components/LinkField';

const PoolsShow = () => (
  <Show>
    <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant="scrollable" />}>
      <Tab label="info">
        <TextField label="ID" source="id" />
        <LinkField label="Location ID" source="location.id" resource="location" action="show" />
        <FunctionField
          label="Position(s)"
          render={(record) => record?.positions?.map((item) => item.display_name).join(', ')}
        />
        <FunctionField
          label="Specialties"
          render={(record) => record?.specialties?.map((item) => item.label).join(', ')}
        />
        <TextField label="Invites Pending" source="onboarding_status.not_accepted" />
        <TextField label="Ready for Review" source="onboarding_status.ready_for_review" />
        <TextField label="Pros in Credentialing" source="onboarding_status.credentialing" />
        <TextField label="W2 Payroll Setup" source="onboarding_status.w2_payroll_setup" />
        <TextField label="Pros in Onboarding" source="onboarding_status.orientation" />
        <TextField label="Pros Ready to Work" source="onboarding_status.complete" />
        <TextField label="Shift Needs" source="shift_needs" />
        <BooleanField label="Requires Pro Review" source="requires_pro_review" />
        <FunctionField
          source="member_condition.required_to_view"
          label="All pros can view job"
          render={(record) => (
            <BooleanField
              record={{ ...record, required_to_view: !record.member_condition?.required_to_view }}
              source="required_to_view"
            />
          )}
        />
        <TextField label="EHR System" source="ehr_system.label" />
        <ArrayField label="Orientation Shift Requirements" source="orientation_shifts">
          <Datagrid bulkActionButtons={false}>
            <TextField label="Shift Type" source="shift_type" />
            <TextField label="Shifts Required" source="shifts_required" />
            <MoneyField label="Base Rate" source="pay_rate_cents" />
          </Datagrid>
        </ArrayField>
      </Tab>
      <Tab label="Professionals" path="professionals">
        <ArrayField label="" source="professionals">
          <Datagrid bulkActionButtons={false}>
            <IdField action="show" resource="professional" source="id" />
            <TextField source="name" label="Name" />
            <TextField source="pool_onboarding_status" label="Onboarding Status" />
          </Datagrid>
        </ArrayField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

PoolsShow.query = gql`
  query GET_ONE($id: Int!) {
    pool(id: $id) {
      id
      location {
        id
        name
      }
      positions {
        id
        display_name
      }
      specialties {
        id
        label
      }
      onboarding_status {
        not_accepted
        ready_for_review
        credentialing
        w2_payroll_setup
        orientation
        complete
      }
      ehr_system {
        id
        label
      }
      shift_needs
      requires_pro_review
      orientation_shifts {
        shift_type
        shifts_required
        pay_rate_cents
      }
      professionals {
        id
        name
        pool_onboarding_status
      }
      member_condition {
        required_to_view
      }
    }
  }
`;

export default PoolsShow;
